import React from 'react';
import { MenuItem } from '@mui/material';
import { IoMdCheckmark } from 'react-icons/io';

interface MenuOptionsProps {
  uID: string | null;
  windowfn: any[];
  axisTitle: string;
  handleClose: (action: string) => void;
  setRenameFunction: (value: boolean) => void;
  setShowTooltip: (value: boolean) => void;
  handleRollup: () => void;
  menuStyle: React.CSSProperties;
  field: any;
}

const MenuOptions: React.FC<MenuOptionsProps> = ({
  uID,
  windowfn,
  axisTitle,
  handleClose,
  setRenameFunction,
  setShowTooltip,
  handleRollup,
  menuStyle,
  field,
}) => {
  const showRename =
    !uID &&
    (windowfn?.length !== 0 ||
      axisTitle === 'Row' ||
      axisTitle === 'Column' ||
      axisTitle === 'Dimension' ||
      axisTitle === 'X Axis' ||
      axisTitle === 'Y Axis' ||
      axisTitle === 'Distribution' ||
      axisTitle === 'Location' ||
      axisTitle === 'Split By' ||
      axisTitle === 'Date');

  return (
    <>
      {/* -------- Rename for Visual -------- */}
      {showRename && (
        <MenuItem
          onClick={() => {
            handleClose('rename');
            setRenameFunction(true);
            setShowTooltip(false);
          }}
          sx={menuStyle}
        >
          Rename for Visual
        </MenuItem>
      )}

      {/* -------- Roll-Up -------- */}
      {uID && (
        <div style={{ display: 'flex' }}>
          <span
            style={{
              color: 'rgb(211, 211, 211)',
              paddingLeft: '5px',
              paddingTop: '4px',
              position: 'absolute',
            }}
          >
            {field.rollupDepth ? <IoMdCheckmark style={{ color: "#7c7979" }} /> : null}
          </span>

          <MenuItem onClick={handleRollup} sx={{ ...menuStyle, width: '100%' }}>
            Roll-Up
          </MenuItem>
        </div>
      )}
    </>
  );
};

export default MenuOptions;
